export default {
  name: 'toggleable',
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    toggle (e) {
      // /*
      console.log('TOGGLE EVENT: ', e)
      console.log('this.expanded: ', this.expanded)
      // */
      e.stopPropagation()
      e.preventDefault()
      this.expanded = !this.expanded
    }
  }
}
